<template>
    <div class="flex flex_column text_left">
        <div class="flex flex_between gray_very_light_background_color">
            <span class="font_bold" style="margin: 5px">
                {{ $t(userRole.title) }}
            </span>
            <el-tooltip placement="top"
                        :content="disabledReason"
                        :disabled="!disabled"
            >
                <md-switch style="margin: 5px"
                           v-model="granted"
                           :disabled="disabled"
                           @change="onRoleChanged"
                ></md-switch>
            </el-tooltip>
        </div>
        <p class="secondary_color" style="margin: 0 5px">
            {{ $t(userRole.description) }}
        </p>
    </div>
</template>

<script>
export default {
    props: {
        userRole: { type: Object, default: null },
        allowChange: { type: Boolean, default: false },
        canEdit: { type: Boolean, default: false },
        granted: { type: Boolean, default: false },
    },
    computed: {
        id() {
            return this.userRole.id;
        },
        disabled() {
            return !this.canEdit;
        },
        disabledReason() {
            if (!this.allowChange) {
                return this.$t('manageUser.permissions.userRoles.changeNotAllowed.roleCannotChange');
            } else if (!this.canEdit) {
                return this.$t('manageUser.permissions.userRoles.changeNotAllowed.missingPermission');
            }

            return "";
        },
    },
    methods: {
        onRoleChanged(value) {
            this.$emit("change", this.userRole, value);
        }
    }
};
</script>